import React from "react";
import Faqs from "../components/Home/Faqs";
import Footer from "../components/Home/Footer";
import Contact from "../components/Home/Contact";
import Aboutus from "../components/Home/Aboutus";
import Hero from "../components/Home/Hero";
import Navbar from "../components/Home/Navbar";
import Count from "../components/Home/Count";

const Home = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Aboutus />
      <Count />
      <Faqs />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
